import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from '../ui/dialog';
import { X } from 'lucide-react';
import { useContactChannel } from '../../hooks/useContactChannel';

interface ContactoDirectoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ContactoDirectoModal: React.FC<ContactoDirectoModalProps> = ({ open, onOpenChange }) => {
  // NZ, u O que viene de NZ: único canal es administración/NZ, nunca el WhatsApp/mail de CX-F.
  const { email, whatsappNumber, whatsappDisplay } = useContactChannel();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md w-full p-0 overflow-hidden">
        <div className="px-6 pt-6 pb-4 relative" style={{ background: 'linear-gradient(180deg, #f5f3ff 0%, #ffffff 100%)' }}>
          <DialogClose className="absolute top-4 right-4 rounded-full w-7 h-7 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
            <X size={16} />
          </DialogClose>
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold" style={{ color: '#1e1b4b' }}>
              Contacto directo
            </DialogTitle>
          </DialogHeader>
        </div>
        <div className="px-6 pb-6 flex flex-col gap-3">
          <p className="text-sm text-gray-500 leading-snug text-justify">
            El asistente resuelve la gran mayoría de las dudas al instante. Si ya lo intentaste y aún no encontraste lo que buscabas, estos son nuestros canales de contacto directo:
          </p>
          {/* WhatsApp */}
          <div className="rounded-2xl border border-green-100 bg-green-50/50 px-5 py-4">
            <p className="text-sm font-semibold text-gray-800 mb-1">WhatsApp Administrativo</p>
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 font-medium text-sm hover:underline"
            >
              {whatsappDisplay}
            </a>
            <p className="text-xs text-gray-400 mt-1">Lun-Vie 7-21hs · Sáb 8-20hs</p>
          </div>
          {/* Email */}
          <div className="rounded-2xl border border-purple-100 bg-purple-50/50 px-5 py-4">
            <p className="text-sm font-semibold text-gray-800 mb-1">Consultas Clínicas</p>
            <a
              href={`mailto:${email}`}
              className="text-[#6D57BC] font-medium text-sm hover:underline"
            >
              {email}
            </a>
            <p className="text-xs text-gray-400 mt-1">Lun-Vie 9-18hs</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactoDirectoModal;
